const offers = [
  {
    id: "1-5-zimmer",
    rooms: 1.5,
    title: "1.5-Zimmer Wohnung",
    description: "Ideal für Studios und kleine Wohnungen.",
    price: "Auf Anfrage",
    features: ["Kleiner Transporter", "1–2 Personen", "Kurzstrecke"],
  },
  {
    id: "2-zimmer",
    rooms: 2,
    title: "2-Zimmer Wohnung",
    description: "Der Klassiker für Paare und Einzelpersonen.",
    price: "Auf Anfrage",
    features: ["Transporter", "2 Personen", "Inkl. Möbelabbau"],
  },
  {
    id: "2-5-zimmer",
    rooms: 2.5,
    title: "2.5-Zimmer Wohnung",
    description: "Mehr Platz, mehr Möbel – wir planen mit.",
    price: "Auf Anfrage",
    features: ["Transporter", "2 Personen", "Inkl. Möbelabbau"],
  },
  {
    id: "3-zimmer",
    rooms: 3,
    title: "3-Zimmer Wohnung",
    description: "Familien- und WG-tauglich, strukturiert und sicher.",
    price: "Auf Anfrage",
    features: ["Grosser Transporter", "2–3 Personen", "Inkl. Montage"],
  },
  {
    id: "3-5-zimmer",
    rooms: 3.5,
    title: "3.5-Zimmer Wohnung",
    description: "Umzug mit mehr Volumen, inklusive Küchenmöbel.",
    price: "Auf Anfrage",
    features: ["Grosser Transporter", "3 Personen", "Inkl. Montage"],
  },
  {
    id: "4-zimmer",
    rooms: 4,
    title: "4-Zimmer Wohnung",
    description: "Für Familien mit viel Mobiliar und Kisten.",
    price: "Auf Anfrage",
    features: ["Grosser Transporter", "3 Personen", "Inkl. Montage"],
  },
  {
    id: "5-zimmer",
    rooms: 5,
    title: "5-Zimmer Wohnung",
    description: "Grosser Haushalt – sorgfältig verpackt und transportiert.",
    price: "Auf Anfrage",
    features: ["2 Fahrzeuge", "3–4 Personen", "Verpackungsservice"],
  },
  {
    id: "6-zimmer",
    rooms: 6,
    title: "6-Zimmer Wohnung",
    description: "Umfangreiche Umzüge mit Planung und Koordination.",
    price: "Auf Anfrage",
    features: ["2 Fahrzeuge", "4 Personen", "Verpackungsservice"],
  },
  {
    id: "7-zimmer",
    rooms: 7,
    title: "7-Zimmer Wohnung",
    description: "Für grosse Wohnungen und kleine Villen.",
    price: "Auf Anfrage",
    features: ["2–3 Fahrzeuge", "4–5 Personen", "Verpackungsservice"],
  },
  {
    id: "8-zimmer",
    rooms: 8,
    title: "8-Zimmer Wohnung",
    description: "Grossprojekt – wir koordinieren den gesamten Ablauf.",
    price: "Auf Anfrage",
    features: ["Mehrere Fahrzeuge", "Team vor Ort", "Verpackungsservice"],
  },
  {
    id: "mehr-als-8",
    rooms: 8,
    title: "Mehr als 8 Zimmer",
    description: "Für Liegenschaften und besondere Projekte.",
    price: "Auf Anfrage",
    features: ["Individuelle Planung", "Besichtigung möglich"],
  },
];

export const getOfferById = (id) => offers.find((o) => o.id === id);

export default offers;